import React from 'react'
import { Box, Typography } from '@mui/material'

interface PageHeaderProps {
  title: string
  subtitle: string
  actions?: React.ReactNode
}

const PageHeader = ({ title, subtitle, actions }: PageHeaderProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 2,
      mb: 3,
    }}
  >
    <Box>
      <Typography
        sx={{
          fontSize: { xs: '20px', sm: '24px' },
          fontWeight: 700,
          color: 'text.primary',
          lineHeight: 1.3,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: '14px',
          color: 'text.secondary',
          mt: 0.5,
        }}
      >
        {subtitle}
      </Typography>
    </Box>
    {actions}
  </Box>
)

export default PageHeader
